/***************************************************************************/
"use client";
/***************************************************************************/

import React from "react";
import If from "../if";
import { FormMessage } from "./form-message";

const FieldErrors: React.FC<{
  errors?: string[];
}> = ({ errors }) => {
  return (
    <If condition={(errors ?? []).length > 0}>
      <If.True>
        <FormMessage className="flex flex-col">
          {errors?.map((message, index) => <span key={index}>{message}</span>)}
        </FormMessage>
      </If.True>
    </If>
  );
};

export { FieldErrors };
